export default "__VITE_ASSET__Cxz5mNja__"